import * as Reducers from './user-tasks-reducers';
import * as MetaReducers from './user-tasks.metareducer';

export const UserTasksReducers = { Reducers,  MetaReducers };

